/**
 * Notes API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { apiTransport as router } from './transport';

export const notesApi = {
  getAll: async () => router.get<unknown[]>('/notes')
};
